import React from 'react';
import { useTranslation } from 'react-i18next';
import { LegalLayout, LegalSection } from '../../components/LegalLayout';

/**
 * TermsPage — Termini e Condizioni d'uso.
 *
 * ★ 2026-08-27 (Phase 57.B) — Terms i18n (IT/EN/ES).
 */
export default function TermsPage() {
  const { t } = useTranslation();
  return (
    <LegalLayout
      docType="terms"
      title={t('legal.terms.pageTitle', 'Termini e Condizioni')}
      intro={t('legal.terms.intro', '')}
    >
      <LegalSection id="s1" title={t('legal.terms.s1Title', '1. Servizi')}>{t('legal.terms.s1Body', '')}</LegalSection>
      <LegalSection id="s2" title={t('legal.terms.s2Title', '2. Registrazione')}>{t('legal.terms.s2Body', '')}</LegalSection>
      <LegalSection id="s3" title={t('legal.terms.s3Title', '3. Uso consentito')}>{t('legal.terms.s3Body', '')}</LegalSection>
      <LegalSection id="s4" title={t('legal.terms.s4Title', '4. IP')}>{t('legal.terms.s4Body', '')}</LegalSection>
      <LegalSection id="s5" title={t('legal.terms.s5Title', '5. Responsabilità')}>{t('legal.terms.s5Body', '')}</LegalSection>
      <LegalSection id="s6" title={t('legal.terms.s6Title', '6. Legge')}>{t('legal.terms.s6Body', '')}</LegalSection>
    </LegalLayout>
  );
}
